import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../../lib/router/withRouter';
import { versionActions } from '../../store/modules/version';
import VersionListWrap from '../../views/version/list/VersionListWrap';
import { _LIST_PAGINATION_MODEL } from '../../store/modules/app/models';
import { VERSION_LIST_SEARCH_OPTION_MODEL, VERSION_LIST_SORT_OPTION_MODEL } from '../../store/modules/version/model';

class VersionListContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  initiate = () => {
    const { location } = this.props;

    /**
     *  페이지에 처음 접근하는 것이 아닐 경우, 이전 검색조건으로 검색한다.
     */
    if (location.state) {
      this.getList({
        searchData: location.state.searchData,
        searchOption: location.state.searchOption,
        sortOption: location.state.sortOption,
        pagination: location.state.pagination,
      });
    } else {
      /**
       *  페이지에 처음 접근하면 초기화된 검색 조건으로 검색한다.
       */
      this.getList({
        searchData: VERSION_LIST_SEARCH_OPTION_MODEL,
        searchOption: VERSION_LIST_SEARCH_OPTION_MODEL,
        sortOption: VERSION_LIST_SORT_OPTION_MODEL,
        pagination: _LIST_PAGINATION_MODEL,
      });
    }
  };

  getList = (data) => {
    const { getVersionList, versionList, history, setData } = this.props;
    const { searchData, searchOption, sortOption, pagination } = versionList;

    /**
     *  서버에 요청
     */
    getVersionList({
      searchOption,
      sortOption,
      pagination,
      ...data,
    });

    /**
     *  새로고침 시에도 검색 UI 데이터를 유지해준다
     */
    if (data.searchData) {
      setData({
        path: ['versionList', 'searchData'],
        value: data.searchData,
      });
    }

    /**
     *  history 에 검색조건을 저장한다
     */
    history.replace({
      ...history.location,
      state: {
        searchData,
        searchOption,
        sortOption,
        pagination,
        ...data,
      },
    });
  };

  render() {
    const { versionList, setData } = this.props;

    return <VersionListWrap versionList={versionList} getList={this.getList} setData={setData} />;
  }
}

const mapStateToProps = (state) => {
  return {
    versionList: state.version.versionList,
  };
};

const mapDispatchToProps = {
  setData: versionActions.setData,
  getVersionList: versionActions.getVersionList,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(VersionListContainer));
